import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IScheduleMessageState } from "../../Typings/MessageState";
import { IMessageScheduleQueue } from "../../Typings/MessageText";
import { RootState } from "../Store";
import { generateScheduleDateErrorMessage } from "../../../MessageComponents/Constants/MessageConstants";

const defaultScheduleMessageState: IScheduleMessageState = {
  messageType: "DirectTextMessage",
  msgListQueue: [],
  scheduleDateTime: null,
  showScheduleOptions: false,
};

export const MessageDialogScheduleSlice = createSlice({
  name: "messageDialogSchedule",
  initialState: defaultScheduleMessageState,
  reducers: {
    setMsgListQueue: (state, action: PayloadAction<IMessageScheduleQueue[]>) => {
      state.msgListQueue = action.payload;
    },
    pushMessageToQueue: (state, action: PayloadAction<IMessageScheduleQueue>) => {
      state.msgListQueue.push(action.payload);
    },
    deleteMessageFromQueue: (state, action: PayloadAction<IMessageScheduleQueue>) => {
      state.msgListQueue = state.msgListQueue.filter((msg) => msg.id !== action.payload.id);
    },
    clearMsgListQueue: (state) => {
      state.msgListQueue = [];
    },
    setScheduleDateTime: (state, action: PayloadAction<{ time: string | null }>) => {
      state.scheduleDateTime = action.payload.time;
      state.scheduleDateTimeErrorMessage = generateScheduleDateErrorMessage(action.payload);
    },
    setScheduleDateTimeErrorMessage: (state, action: PayloadAction<string | undefined>) => {
      state.scheduleDateTimeErrorMessage = action.payload;
    },
    setShowScheduleOptions: (state, action: PayloadAction<boolean>) => {
      state.showScheduleOptions = action.payload;
    },
    setScheduleMessageType: (state, action: PayloadAction<string>) => {
      state.messageType = action.payload;
    },
    resetScheduleMessageState: (state) => {
      state.msgListQueue = [];
      state.scheduleDateTime = null;
      state.scheduleDateTimeErrorMessage = undefined;
      state.showScheduleOptions = false;
    },
  },
});
// Action creators are generated for each case reducer function
export const {
  setMsgListQueue,
  clearMsgListQueue,
  deleteMessageFromQueue,
  setScheduleDateTime,
  setScheduleDateTimeErrorMessage,
  setShowScheduleOptions,
  setScheduleMessageType,
  pushMessageToQueue,
  resetScheduleMessageState,
} = MessageDialogScheduleSlice.actions;

export const selectMessageScheduleState = (state: RootState) => state.messageDialogSchedule;

export default MessageDialogScheduleSlice.reducer;
